module.exports = __webpack_public_path__ + "img/jeshoots-com-mSESwdMZr-A-unsplash.9b65a300.jpg";